import styled from "styled-components";

import { RigFracFields } from "./RigFracFields";
import { useRigFracDetailHover } from "./hooks/adapters/useRigFracDetailHover";

/**
 * RigFracDetail renders a hover tooltip on the map showing whatever
 * properties the hovered Rig/Frac Crew tile feature carries. All imperative
 * Mapbox interactions (mouse events, feature queries, debounced display,
 * overflow adjustment) are delegated to the `useRigFracDetailHover` adapter
 * hook.
 */
function RigFracDetail() {
  const { rigFracDetail, popupRef } = useRigFracDetailHover();

  if (!rigFracDetail.show) {
    return null;
  }

  return (
    <Wrapper ref={popupRef} left={rigFracDetail.x} top={rigFracDetail.y}>
      <RigFracFields properties={rigFracDetail.properties} />
    </Wrapper>
  );
}

export default RigFracDetail;

const Wrapper = styled.div`
  position: absolute;
  left: ${(props) => (props.left ? props.left : 0)}px;
  top: ${(props) => (props.top ? props.top : 0)}px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 200px;
  border-radius: 10px;
  background: radial-gradient(
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.15) 80%,
    rgba(0, 0, 0, 0.1) 100%
  );
  backdrop-filter: blur(4px);
  color: white;
  font-family: "Open Sans", sans-serif;
  padding: 10px;
  max-width: 500px;
  margin: 0;
  z-index: 20;
  pointer-events: none;
  box-shadow: var(--shadow-drawer);
`;
